module.exports = __webpack_public_path__ + "img/QuoteOnly.e8e67d5a.png";